import CrmComntrol from '../../components/control/crm';

const CrmControlPage = () => {
  return <CrmComntrol />;
};

export default CrmControlPage;
